module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', [_c('b-input-group', [_c('b-input-group-prepend', [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.home()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "home"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.path.length <= 1
    },
    on: {
      "click": function($event) {
        return _vm.parent()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "chevron-left"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "path-id",
      "type": "text",
      "autofocus": "",
      "required": "",
      "placeholder": "Enter the file system path"
    },
    model: {
      value: (_vm.path),
      callback: function($$v) {
        _vm.path = $$v
      },
      expression: "path"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.pageChange()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "chevron-right"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-col', [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "id": "filter-id",
      "type": "text",
      "autofocus": "",
      "required": "",
      "placeholder": "Filter the current folder"
    },
    on: {
      "keyup": function($event) {
        return _vm.filterData()
      }
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "variant": "primary"
    }
  }, [_c('icon', {
    attrs: {
      "name": "filter"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', [_c('b-table', {
    attrs: {
      "bordered": "",
      "striped": "",
      "hover": "",
      "responsive": "",
      "fields": _vm.fields,
      "items": _vm.files,
      "current-page": _vm.pageNo,
      "per-page": _vm.rowsPerPage
    },
    on: {
      "row-clicked": _vm.onRowClick
    },
    scopedSlots: _vm._u([{
      key: "cell(size)",
      fn: function(file) {
        return [(file.item.folder === false) ? _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("size")(file.item.size)) + " \n\t\t\t\t\t\t"), _c('icon', {
          staticStyle: {
            "color": "#777"
          },
          attrs: {
            "name": "file"
          }
        })], 1) : _vm._e(), _vm._v(" "), (file.item.folder === true) ? _c('span', [_c('icon', {
          staticStyle: {
            "color": "#777"
          },
          attrs: {
            "name": "folder"
          }
        })], 1) : _vm._e()]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', [_vm._v("\n\t\t\t" + _vm._s(_vm._f("integer")(_vm.totalRows)) + " Files\n\t\t")]), _vm._v(" "), _c('b-col', {
    staticClass: "d-flex justify-content-end"
  }, [_c('span', {
    staticClass: "d-inline-flex p-2"
  }, [_c('b-form-select', {
    attrs: {
      "id": "per-page-select"
    },
    model: {
      value: (_vm.rowsPerPage),
      callback: function($$v) {
        _vm.rowsPerPage = $$v
      },
      expression: "rowsPerPage"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": 10
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('b-form-select-option', {
    attrs: {
      "value": 20
    }
  }, [_vm._v("20")]), _vm._v(" "), _c('b-form-select-option', {
    attrs: {
      "value": 50
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('b-form-select-option', {
    attrs: {
      "value": 100
    }
  }, [_vm._v("100")])], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "d-inline-flex p-2"
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.rowsPerPage
    },
    model: {
      value: (_vm.pageNo),
      callback: function($$v) {
        _vm.pageNo = $$v
      },
      expression: "pageNo"
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-99654442","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FileSystemExplorer.vue
// module id = 2146
// module chunks = 1